import ChessRestClient from '@/Api/ChessRestClient';
import {useMutation} from '@tanstack/react-query';

export type ResumeCsocSubscriptionPayload = {
  order_id: string;
  resume_date?: string; // dd/mm/yyyy (optional, defaults to today)
  // Optional usage-tracking context, sent only when this resume was
  // triggered from the paused-subscription banner (not the per-card resume
  // button) — the backend logs BANNER_EVENT off these instead of a
  // dedicated logging endpoint.
  source?: 'meetings_tab' | 'subscription_tab';
  platform?: 'web' | 'app';
};

export default function useResumeCsocSubscription(
  handleOnSuccess?: (data: any) => void,
  handleOnError?: (error: any) => void,
) {
  const mutation = useMutation({
    mutationFn: async (payload: ResumeCsocSubscriptionPayload) => {
      const response = await ChessRestClient.post(
        'subscription/v1/csoc/resume-subscription',
        payload,
      );
      return response.data;
    },
    onSuccess: data => {
      if (handleOnSuccess) handleOnSuccess(data);
    },
    onError: error => {
      if (handleOnError) handleOnError(error);
    },
  });

  return {
    ...mutation,
  };
}
